// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-1NWmC","col":"col-r34B2","footer__item":"footer__item-l3O0R"};